import { imageUrl } from "@/utils/constants";

import FA_LANG from "@/assets/locale/fa";
import ResponseInput from "./inputs/ResponseInput";
import icons from "@/assets/icons";
import { useId } from "react";

export type QuizProps = {
  selectedQuiz: Quiz;
  updateQuizDetail: Function;
  addNewChoice?: Function;
  removeChoice?: Function;
  updateQuestion?: Function;
  addNewAnswer?: Function;
  removeAnswer?: Function;
  questionDirection: string;
};

export default function Drawing({
  selectedQuiz,
  updateQuizDetail,
  updateQuestion,
  addNewChoice,
  removeChoice,
  questionDirection,
}: QuizProps) {
  const handleQuestionChange = (value: string, i: number) => {
    const updatedSelectedQuiz: Quiz = {
      ...selectedQuiz,
      question: value,
    };
    if (updateQuestion) updateQuestion(updatedSelectedQuiz);
  };

  function handleQuestionFileChange(image: any): void {
    const updatedSelectedQuiz: Quiz = {
      ...selectedQuiz,
      question_file: image,
      question_link: "",
      question_file_id: undefined,
    };
    if (updateQuestion) updateQuestion(updatedSelectedQuiz);
  }

  const addQuizDetails = (i: number) => {
    if (selectedQuiz.quiz_detail_json.length < 4) {
      addNewChoice!(
        {
          id: "choice" + (i + 1),
          choice: {
            fileId: "",
            text: "",
            url: "",
          },
          isCorrect: false,
          ordering: i + 1,
          correctOrder: i + 1,
          letterWise: false,
          isChoice: true,
          answers: [
            {
              id: "answer" + (i + 1) + "1",
              answer: {
                fileId: "",
                text: "",
                url: "",
              },
            },
          ],
        },
        i
      );
    }
  };

  const removeQuizDetails = (i: string) => {
    if (selectedQuiz.quiz_detail_json?.length > 2) {
      removeChoice!(i);
    }
  };

  const handleAddInputs = (i: number) => {
    if (
      selectedQuiz.quiz_detail_json?.length > 0 &&
      selectedQuiz.quiz_detail_json?.length < 5
    ) {
      addQuizDetails(i);
    }
  };

  const handleDeleteInputs = (i: string) => {
    if (selectedQuiz.quiz_detail_json?.length > 2) {
      removeQuizDetails(i);
    }
  };

  const updateChoiceImage = (image: any, i: number) => {
    let updated = selectedQuiz.quiz_detail_json?.map((details, index) =>
      i === index
        ? {
            ...details,
            choice: {
              ...details?.choice,
              url: undefined,
              fileId: image,
            },
          }
        : details
    );
    updateQuizDetail(updated[i]);
  };

  const handleCorrectness = (i: number) => {
    let updated = selectedQuiz.quiz_detail_json?.map((choice, index) =>
      i === index ? { ...choice, isCorrect: !choice?.isCorrect } : choice
    );
    updateQuizDetail(updated[i]);
  };

  const updateChoiceValue = (value: string, i: number) => {
    let updated = selectedQuiz.quiz_detail_json?.map((details, index) =>
      i === index
        ? { ...details, choice: { ...details.choice, text: value } }
        : details
    );
    updateQuizDetail(updated[i]);
  };

  const renderInputs = () => {
    return selectedQuiz.quiz_detail_json.map((_, i) => (
      <div className={`flex items-start  w-full  `} key={i}>
        <div className="flex flex-col justify-end items-end grow self-stretch rounded-xl w-full ">
          <div className="flex p-[6px] flex-col justify-center items-end gap-[6px] grow self-stretch rounded-xl bg-blue-10">
            <div className="flex justify-between items-center self-stretch">
              <div className="flex justify-start items-center gap-1">
                <div className="flex p-1 flex-col items-center gap-[10px] rounded-[100px] bg-bg-white">
                  <div className="flex justify-start items-center gap-1">
                    <div className="text-sm text-nowrap text-text-caption">
                      {FA_LANG.CHOICE} {i + 1}
                    </div>
                    <button
                      className="w-4 h-4 text-text-caption hover:text-success-line"
                      onClick={() => handleCorrectness(i)}
                      tabIndex={-1}
                    >
                      {selectedQuiz.quiz_detail_json?.[i]?.isCorrect
                        ? icons.tickCircleFill
                        : icons.tickCircle}
                    </button>
                  </div>
                </div>
              </div>
              {selectedQuiz?.quiz_detail_json?.length > 2 && (
                <button
                  className="flex justify-center items-center w-6 h-6 "
                  onClick={() =>
                    handleDeleteInputs(selectedQuiz?.quiz_detail_json?.[i]?.id)
                  }
                  tabIndex={-1}
                >
                  {icons.closeSquare}
                </button>
              )}
            </div>
            <ResponseInput
              placeHolder={FA_LANG.CHOICE}
              styleClass="h-[280px] min-w-[250px]"
              inputValue={selectedQuiz.quiz_detail_json?.[i]?.choice?.text}
              valueUpdated={updateChoiceValue}
              index={i}
              hasFile={true}
              handleImageChange={updateChoiceImage}
              imageUrl={
                selectedQuiz?.quiz_detail_json &&
                selectedQuiz.quiz_detail_json[i]?.choice?.url
                  ? imageUrl + selectedQuiz.quiz_detail_json[i]?.choice?.url
                  : selectedQuiz?.quiz_detail_json &&
                      selectedQuiz.quiz_detail_json[i]?.choice?.fileId
                    ? URL.createObjectURL(
                        selectedQuiz.quiz_detail_json[i]?.choice?.fileId
                      )
                    : undefined
              }
              imageHeight="h-[250px]"
              imageWidth="w-[250px]"
              id={`file-input-choice-test-${image_id + i}`}
              tabIndex={i + 1}
            />
          </div>
        </div>
        {selectedQuiz?.quiz_detail_json?.length <= 3 && (
          <div className="flex items-center justify-center self-center z-20 ">
            <button
              className=" bg-bg-white w-6 h-6 rounded-full flex items-center justify-center p-1 hover:bg-tertiary"
              onClick={() => handleAddInputs(i + 1)}
              tabIndex={-1}
            >
              {icons.add}
            </button>
          </div>
        )}
      </div>
    ));
  };
  function handleQuestionAudioChange(audio: any): void {
    const updatedSelectedQuiz: Quiz = {
      ...selectedQuiz,
      question_voice: audio,
      question_voice_link: undefined,
    };
    if (updateQuestion) updateQuestion(updatedSelectedQuiz);
  }
  const image_id = useId();

  return (
    <div className="flex flex-col gap-8 items-start w-full">
      <ResponseInput
        inputValue={selectedQuiz.question}
        valueUpdated={handleQuestionChange}
        placeHolder={FA_LANG.QUESTION_INPUT}
        handleImageChange={handleQuestionFileChange}
        id={`file-input-question-test-${image_id}`}
        styleClass=" h-[400px] gap-6 "
        index={0}
        hasFile={true}
        imageUrl={
          selectedQuiz.question_link
            ? imageUrl + selectedQuiz.question_link
            : selectedQuiz.question_file
              ? URL.createObjectURL(selectedQuiz.question_file)
              : undefined
        }
        tabIndex={0}
        imageHeight="h-[350px]"
        imageWidth="w-[300px]"
        questionInput={true}
        questionDirection={questionDirection}
        handleVoiceChange={handleQuestionAudioChange}
        hasAudio={true}
        inputVoice={selectedQuiz.question_voice_link}
      />
      {/* <div
        className={`flex w-full overflow-auto ${
          selectedQuiz?.quiz_detail_json?.length <= 3 ? "" : "gap-x-1.5"
        }`}
      >
        {renderInputs()}
      </div> */}
    </div>
  );
}
